<template>
  <div class="Details">
    <div class="bigImg">
      <div class="top-left">
        <img class="top-img" src="../../static/index/top-app.png" alt="" />
        <div class="top-title">细致交易 风险防控</div>
        <div class="top-titles">专业黄金，优质服务</div>
        <img
          class="top-imgs"
          @click="toLoad"
          src="../../static/index/top-download.png"
          alt=""
        />
        <div class="top-flex">
          <div class="top-bottoms">
            <img src="../../static/index/smartphone-device.png" alt="" />
            <div>
              <span>支持多平台</span>
              <span>双端互通</span>
            </div>
          </div>
          <div class="top-line"></div>
          <div class="top-bottoms">
            <img src="../../static/index/verified-user.png" alt="" />
            <div>
              <span>简单</span>
              <span>易用</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detailTable">
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 1130px;margin: 0 auto;"
        :header-cell-style="{textAlign: 'center',background:'rgb(250, 35, 20)',color:'#fff',border:'none'}"
        :header-row-style="{height:'80px'}"
        :cell-style="{ textAlign: 'center',borderRight:'none'  }">
        <el-table-column
          prop="date"
          label=""
          min-width="20%">
        </el-table-column>
        <el-table-column
          prop="name"
          label="伦敦金"
          min-width="40%">
        </el-table-column>
        <el-table-column
          prop="address"
          label="伦敦银"
          min-width="40%">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import NP from 'number-precision';
import eventBusMitter from '../../utils/eventbus'

  export default {
    name: 'Details',
     metaInfo: {
    title: '红狮金业,贵金属投资,现货黄金白银交易,伦敦金伦敦银开户,黄金交易投资',
    meta: [
      { name: 'keywords', content: '红狮金业,红狮启富,黄金交易平台,贵金属交易,贵金属投资,贵金属平台,现货黄金开户,正规靠谱外汇交易,正规网上交易平台' },
      { name: 'description', content: '红狮金业是专业值得信赖的国际投资交易平台,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }
    ]
  }, 

    data () {
      return {
        tableData: [{
          date: '合约单位',
          name: '100',
          address: '5000'
        }, {
          date: '货币单位',
          name: 'USD',
          address: 'USD'
        },{
          date: '报价小数点',
          name: '2',
          address: '3'
        }, {
          date: '点差',
          name: '根据市况浮动',
          address: '根据市况浮动'
        }, {
          date: '单笔交易手数',
          name: '0.01手～20.00手',
          address: '0.01手～20.00手'
        },{
          date: '手数差值',
          name: '0.01手',
          address: '0.01手'
        }, {
          date: '最小挂单距离',
          name: '100点(根据市况浮动)',
          address: '100点(根据市况浮动)'
        },{
          date: '初始保证金',
          name: '合约价值*0.5%',
          address: '合约价值*0.5%'
        }, {
          date: '假期保证金',
          name: '双倍',
          address: '双倍'
        }, {
          date: '锁仓保证金',
          name: '按所需保证金较多的订单收取',
          address: '按所需保证金较多的订单收取'
        },{
          date: '库存费',
          name: '根据市况浮动',
          address: '根据市况浮动'
        },{
          date: '三天利息日',
          name: '周四',
          address: '周四'
        }, {
          date: '交易时间GMT+8',
          name: '周一：06:00-24:00 \n 周二：00:00-04:55 06:00-24:00 \n 周三：00:00-04:55 06:00-24:00 \n 周四：00:00-04:55 06:00-24:00 \n 周五：00:00-04:55 06:00-24:00 \n 周六：00:00-04:45',
          address: '周一：06:00-24:00 \n 周二：00:00-04:55 06:00-24:00 \n 周三：00:00-04:55 06:00-24:00 \n 周四：00:00-04:55 06:00-24:00 \n 周五：00:00-04:55 06:00-24:00 \n 周六：00:00-04:45'
        }, {
          date: '结算时间',
          name: '夏今：5点为结筤时间 \n 冬令：6点为结算时间',
          address: '夏今：5点为结筤时间 \n 冬令：6点为结算时间'
        }],
        screenWidth:null,
        baseData:{},
        goldList:[],
        sliverList:[]
      }
    },
    created(){
      eventBusMitter.emit('eventtab', { key: false })

      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
      this.baseData=this.$parent.sblsBaseData
      setTimeout(() => {
        this.goldList= this.getData('GOLD')
        this.sliverList= this.getData('SILVER')
        this.tableData[12].name=this.goldList.join('')
        this.tableData[12].address=this.goldList.join('')
      }, 1000);
      
    
    },
    methods:{
      //获取交易时间
      getData(type){
        
        const weekArr = ['日', '一', '二', '三', '四', '五', '六'];
        // 交易时间
        let sessions = this.baseData[type].sessionsList;
        if (!sessions || sessions.length === 0) {
           return '';
         }
         let dayList = [];
        let timeResult = [];
  sessions.forEach((item) => {
    if (item.type === 1 && item.close !== 0) {
      let dateList = '';
      let startHour = NP.divide(Number(item.open), 60);
      
      let endHour = NP.divide(Number(item.close), 60);
      if (startHour > 24) {
        startHour = NP.minus(Number(startHour), 24);
      }
   
      if (endHour > 24) {
        endHour = NP.minus(Number(endHour), 24);
      }
      let start = this.time(Math.trunc(startHour), item.open % 60);
      let end = this.time(Math.trunc(endHour), item.close % 60);
      if (end.startsWith('00:')) {
        end = end.replaceFirst('00:', '24:');
      }

      let times = start + '-' + end;
      if (dayList.indexOf(item.day) > -1) {
        dateList= timeResult[item.day];
      } else {
        dayList.push(item.day);
      }
      dateList = dateList + ' ' + times;
      timeResult[item.day] = dateList;
    }
  });
  timeResult.forEach((item, i) => {
    if(i === 0) {
      timeResult[i] ='周日: ' + item+'\n';
      } else if (i === 1) {
      timeResult[i] = '周一: ' + item+'\n';
      } else if (i === 2) {
      timeResult[i] = '周二: ' + item+'\n';
      } else if (i === 3) {
      timeResult[i] = '周三: ' + item+'\n';
      } else if (i === 4) {
      timeResult[i] = '周四: ' + item+'\n';
      } else if (i === 5) {
      timeResult[i] = '周五: ' + item+'\n';
      } else {
      timeResult[i] = '周六: ' + item+'\n';
      }
       });
       timeResult = timeResult.filter(t => t)
      return timeResult
      },
       time (hour, min) {
        return (
            (hour > 9 ? hour : '0' + hour) +
           ':' +
          (min > 9 ? min : '0' + min) +
          ':' +
           '00'
        );
      },
      toLoad(){
            eventBusMitter.emit('eventNas', {key:4})

        this.$router.push({
              name: "Appdownload",
               query: {
                showTop:true
              }
            });
      }
    },
     mounted(){
      //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
        console.log('屏幕宽度',this.screenWidth)
      })()
    };
    },
     watch: {
    screenWidth(n) {
      console.log('屏幕发生了变化888',n)
      if (n <= 500) {
        this.$router.push({
          name: "wapDetail",
        });
      }
    },
    
  },
  }
</script>

<style lang="less" scoped>
  .Details{
    width: 100%;
    .bigImg{
      width: 100%;
      height: 810px;
      background: url('../../static/details/topbg.png') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding-top: 175px;
       .top-left {
      display: flex;
      flex-direction: column;
      margin: 0 0 0 300px;
      // align-items: center;
      .top-title {
        color: #fff;
        font-size: 80px;
        font-weight: 700;
        line-height: 106px;
        margin: 34px 0 26px 0;
      }
      .top-img {
        width: 139px;
        height: 38px;
      }
      .top-imgs {
        margin: 66px 0 110px 0;
        width: 198px;
        height: 56px;
        cursor: pointer;
      }
      .top-titles {
        color: #fff;
        font-size: 26px;

        line-height: 34px;
      }
    }
    .top-flex {
      display: flex;
      align-items: center;
    }
    .top-line {
      width: 1px;
      height: 60px;
      margin: 0 32px;
      background: #fff;
    }
    .top-bottoms {
      display: flex;
      align-items: center;
      div {
        display: flex;
        // align-items: center;
        flex-direction: column;
        color: #fff;
        font-size: 16px;
        line-height: 26px;
        margin-left: 12px;
      }
    }
    }
    .detailTable{
      width: 100%;
      box-sizing: border-box;
      padding: 105px 0px;
      margin: 0 auto;
      /deep/ .el-table__row{
        height: 89px;
      }
      /deep/ .el-table__row--striped{
        height: 80px;
      }
      /deep/ .el-table__row td:nth-child(1){
        font-weight: 600 !important;
      }
       /deep/ .el-table__row td:nth-child(2){
      
        color: #D18A1F !important;
      }
    

      /deep/ .el-table .cell {
        white-space: pre-line;
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td{
        background: #fff;
      }
      ::v-deep .el-table__header-wrapper{
         border-collapse: collapse;
         border: none;
      }
    }
  }
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
  .Details{
    .bigImg{
      .top-left{
        margin: 0 0 0 150px;
        .top-title{
          font-size: 60px;
        }
      }
    }
  }
  }
</style>